import React, { createContext, useCallback, useContext, useState } from 'react';

import { TailwindWrapper } from '@utils/TailwindWrapper';

import PlusBlockerDialog from './PlusBlockerDialog';
import type { FeatureHighlight, PlusBlockerDialogContextValue } from './PlusBlockerDialog.types';

const PlusBlockerDialogContext = createContext<PlusBlockerDialogContextValue | null>(null);

export function PlusBlockerDialogProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [featureHighlight, setFeatureHighlight] = useState<FeatureHighlight>('property-data');

  const openDialog = useCallback((highlight: FeatureHighlight) => {
    setFeatureHighlight(highlight);
    setIsOpen(true);
  }, []);

  const onCloseDialog = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <PlusBlockerDialogContext.Provider
      value={{
        openPlusBlockerDialog: openDialog,
        closePlusBlockerDialog: onCloseDialog
      }}
    >
      {children}
      <TailwindWrapper>
        <PlusBlockerDialog
          isOpen={isOpen}
          onClose={onCloseDialog}
          featureHighlight={featureHighlight}
        />
      </TailwindWrapper>
    </PlusBlockerDialogContext.Provider>
  );
}

export function usePlusBlockerDialog(): PlusBlockerDialogContextValue {
  const ctx = useContext(PlusBlockerDialogContext);
  if (!ctx) {
    throw new Error('usePlusBlockerDialog must be used within PlusBlockerDialogProvider');
  }
  return ctx;
}
